<template>
  <el-tooltip :content="stateLabel" placement="top" :open-delay="300">
    <i
      v-if="state === STATE_CODE.HUY"
      class="fa fa-times-circle color__red icon-status font-size__large"
    ></i>

    <i
      v-if="state === STATE_CODE.CHO_PHE_DUYET"
      class="far fa-clock color__blue icon-status font-size__large"
    ></i>

    <i
      v-if="state === STATE_CODE.DA_PHE_DUYET"
      class="fas fa-check-circle color__green icon-status font-size__large"
    ></i>

    <i
      v-if="state === STATE_CODE.TU_CHOI"
      class="fa fa-ban color__red icon-status font-size__large"
    ></i>
  </el-tooltip>
</template>

<script>
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import constants from "../../../constants";

export default {
  name: "hc-dieuxe-state-icon",
  props: ["state"],
  data() {
    return {
      STATE_CODE: constants.HC_STATE.STATE_CODE.DIEU_XE
    };
  },

  computed: {
    stateLabel() {
      return hanhChinhUtils.getDieuXeStateLabel(this.state);
    }
  },

  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/dieuxe/hc-dieuxe-state-icon.vue